import React from 'react';
import {Formik, Form, Field, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import {controlClass, fieldError, primaryButtonClass, Spinner} from '../formStyles';

const profileSchema = Yup.object({
  name: Yup.string()
    .min(2, 'Full name must be at least 2 characters')
    .required('Full name is required'),
});

export interface ProfileFormValues {
    name: string;
}

interface ProfileFormProps {
    initialValues: ProfileFormValues;
    saving: boolean;
    onSubmit: (values: ProfileFormValues) => Promise<void>;
}

/**
 * Display name only. Email used to be a field here, which was the bug: this form writes the CensorMe
 * profile row, and the row is not the sign-in identity. Email now has its own card.
 */
const ProfileForm: React.FC<ProfileFormProps> = ({initialValues, saving, onSubmit}) => (
  <Formik
    initialValues={initialValues}
    validationSchema={profileSchema}
    enableReinitialize
    onSubmit={async (values, {setSubmitting}) => {
      await onSubmit({name: values.name.trim()});
      setSubmitting(false);
    }}
    validateOnChange={false}
    validateOnBlur={false}
  >
    {({isSubmitting, dirty}) => {
      const busy = isSubmitting || saving;

      return (
        <Form className="mt-5 space-y-3.5">
          <div>
            <label className="mb-1 block text-xs font-medium text-gray-300" htmlFor="name">
                            Full name
            </label>
            <Field
              id="name"
              name="name"
              type="text"
              autoComplete="name"
              placeholder="Jane Doe"
              className={controlClass}
            />
            <ErrorMessage name="name">{fieldError}</ErrorMessage>
          </div>

          <button type="submit" disabled={busy || !dirty} className={primaryButtonClass}>
            {busy && <Spinner />}
            {busy ? 'Saving…' : 'Save name'}
          </button>
        </Form>
      );
    }}
  </Formik>
);

export default ProfileForm;
